import React, { Fragment } from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import { Grid, Cell } from 'styled-css-grid'

import Header from '../components/header'
import Footer from '../components/footer'
import SEO from '../components/seo'
import Words from '../components/blb-words'
import Button from '../components/button'

const StyledGrid = styled(Grid)`
   height: 100vh;

   @media only screen and (max-width: 1200px) {
      grid-template-columns: 1fr;

      .words-cell {
         display: none;
      }
   }
`

const StyledCell = styled(Cell)`
   &.blurb {
      height: auto;
      margin-left: 10vw;
      margin-bottom: 5px;
      align-self: end;
      z-index: 10;
   }

   footer {
      margin-top: 30px;
   }

   &.words-cell {
      justify-self: end;
   }

   @media only screen and (max-width: 1200px) {
      margin-left: 5vw;
      margin-right: 5vw;
   }
`

const HeaderText = styled.h1`
   font-family: 'Righteous', serif;
   font-size: 3.6em;
   color: var(--heading-text-color);

   @media only screen and (max-width: 760px) {
      font-size: 2.5em;
   }

   @media only screen and (max-height: 500px) {
      display: none;
   }
`

const SubText = styled.p`
   font-size: 0.9em;
   color: var(--heading-text-color);
   margin-bottom: 40px;

   @media only screen and (max-height: 500px) {
      font-weight: bold;
   }
`

const GlobalStyles = createGlobalStyle`
    body {
        font-family: 'Montserrat', sans-serif;
    }
`

const IndexPage = () => (
   <Fragment>
      <SEO title="build like beavers®" />
      <GlobalStyles />

      <StyledGrid columns={2}>
         <Cell left={1}>
            <Header />
         </Cell>
         <StyledCell left={1} top={2} className="blurb">
            <HeaderText>Change the environment around you</HeaderText>
            <SubText>
               Software engineering and delivery specialists, enabling clients
               to continuously improve through the application of proven
               alternative practices
            </SubText>
            <a href="mailto:info@buildlikebeavers.com">
               <Button autofocus text="Contact us" />
            </a>
            <Footer />
         </StyledCell>

         <StyledCell className="words-cell" left={2} height={2}>
            <Words />
         </StyledCell>
      </StyledGrid>
   </Fragment>
)

export default IndexPage
